import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusCircle,  Sliders } from 'feather-icons-react/build/IconComponents';
//import Select from 'react-select';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table  from '../../core/pagination/newdatatable.jsx'
import AddShift from '../../core/modals/hrm/addshift.jsx';
import EditShift from '../../core/modals/hrm/editshift.jsx';
import axios from 'axios';

const Shift = () => {
    const [shifts, setShifts] = useState([]);
    const [selectedShiftId, setSelectedShiftId] = useState(null);
    const [shouldReloadData, setShouldReloadData] = useState(false);
    const [search, setSearch] = useState('');

    const fetchShifts = async (search = '') => {
        try {
          const response = await axios.get(`/shifts?search=${encodeURIComponent(search)}`);
          console.log(response.data); 
      
          setShifts(response.data.data.shifts); 
        } catch (error) {
          console.error("Error fetching shifts:", error);
        }
      };
      

  
    useEffect(() => {
        fetchShifts(search); // Pass search term to fetchShifts
    }, [search, shouldReloadData]); // Ensure shouldReloadData is included to reload on change

    const handleReloadData = () => {
        setShouldReloadData(!shouldReloadData);
    };

    const columns = [
        {
            title: "Shift Name",
            dataIndex: "shiftname",
            sorter: (a, b) => a.shiftname.length - b.shiftname.length,
        },
        {
            title: "Time",
            dataIndex: "time",
            sorter: (a, b) => a.time.length - b.time.length,
        },
        {
            title: "Week Off",
            dataIndex: "weekoff",
            sorter: (a, b) => a.weekoff.length - b.weekoff.length,
        },
        {
            title: "Created On",
            dataIndex: "createdon",
            sorter: (a, b) => a.createdon.length - b.createdon.length,
        },
        {
            title: "Status",
            dataIndex: "status",
            sorter: (a, b) => a.status.length - b.status.length,
        },
        {
            title: "Actions",
            dataIndex: "actions",
            sorter: (a, b) => a.createdby.length - b.createdby.length,
        },
    ];

    const MySwal = withReactContent(Swal);
    const showConfirmationAlert = (shiftId) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                deleteShift(shiftId);
                MySwal.fire({
                    title: 'Deleted!',
                    text: 'Your file has been deleted.',
                    className: "btn btn-success",
                    confirmButtonText: 'OK',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                });
                handleReloadData()
            } else {
                MySwal.close();
            }
        });
    };
    
    const deleteShift = async (shiftId) => {
        try {
            await axios.delete(`/shifts/${shiftId}`); 
        } catch (error) {
            console.error("Error deleting shift:", error);
        }
    };

    const handleLinkClick = async (shiftId) => {
        setSelectedShiftId(shiftId);
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };
    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Shift</h4>
                                <h6>Manage your employees shift</h6>
                            </div>
                        </div>
                      
                        <div className="page-btn">
                        
                               <Link
                               to="#"
                               className="btn btn-added"
                               data-bs-toggle="modal"
                               data-bs-target="#add-units"
                                 >
                               <PlusCircle className="me-2" />
                               Add New Shift
                                 </Link>
                          
                           
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                            <div className="search-set">
                            <div className="search-input">
                             
                             {/*                  search              */}
                              <input
                                // type="text"
                                type="search"
                                placeholder="Search"
                                className="form-control form-control-sm formsearch"
                                value={search}
                                onChange={handleSearchChange}
                                // onChange={(e) => setSearch(e.target.value)}
                              />
                              
                              <Link to className="btn btn-searchset">
                                <i data-feather="search" className="feather-search" />
                              </Link>
                            </div>
                            <div className='wordset'>
                            <ul>
                                        <li>
                                            <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="pdf">
                                               <img src="assets/img/icons/pdf.svg" alt="pdf" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="excel">
                                               <img src="assets/img/icons/excel.svg" alt="excel" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="print">
                                                <img src="assets/img/icons/printer.svg" alt="print" />
                                            </a>
                                        </li>
                                    </ul>
                            </div>
                          </div>
                               
                          <div className="search-set">
                                <a href="#" className="btn btn-filter" id="filter_search">
                                    <Sliders className="me-2" />Filter
                                </a>
                            </div>
                            </div>
                        
                            <div className="table-responsive">
                                <Table 
                                    columns={columns} 
                                    dataSource={shifts.map((shift) => ({
                                        key: shift._id,
                                        shiftname: shift.shiftInfo.shiftName,
                                        time: `${shift.shiftInfo.from} - ${shift.shiftInfo.to}`,
                                        weekoff: shift.shiftInfo.weekOff,
                                        createdon: shift.createdAt.split('T')[0],
                                        status: (
                                            <span className="badge badge-linesuccess">
                                                <Link to="#"> {shift.shiftInfo.status ? 'Active' : 'Inactive'}</Link>
                                            </span>
                                        ),
                                        actions: (
                                            <td className="action-table-data">
                                                 
                                                   <Link
                                                   className="me-2 p-2"
                                                   to="#"
                                                   data-bs-toggle="modal"
                                                   data-bs-target="#edit-units"
                                                   onClick={() => handleLinkClick(shift._id)}
                                                    >
                                                        <i data-feather="download" className="feather-edit"></i>
                                                    </Link>
                                                
                                                
                                                   <Link 
                                                   className="confirm-text me-2 p-2" 
                                                   to="#"
                                                   onClick={() => showConfirmationAlert(shift._id)}
                                                    >
                                                        <i
                                                            data-feather="trash-2"
                                                            className="feather-trash-2"
                                                        ></i>
                                                    </Link>
                                                
 
                                            </td>
                                        ),
                                    }))} 
                                />
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
            <AddShift onShiftAdded={handleReloadData}/>
            <EditShift onShiftAdded={handleReloadData} shiftId={selectedShiftId}/>
        </div>
    )
}

export default Shift
